// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1lZZE","tab":"Tabs_tab__2saek","tabActive":"Tabs_tabActive__29OxN"};